

export class SearchEntryState {
    type: 'Articles' | 'Products' | null = null;

    title: string;
    url: string;
    description: string;
    tags: string[];
    image: string;

    constructor(
        type:  'Articles' | 'Products',
        title: string,
        url: string,
        description: string,
        tags: string[],
        image: string
    ) {
        this.type = type;
        this.image = image;
        this.title = title;
        this.url = url;
        this.description = description;
        this.tags = tags;
    }
}
